import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../supabase/supabaseClient";
import { useUser } from "../contexts/UserContext";

export default function OpportunityEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();

  const [form, setForm] = useState({
    title: "",
    category: "open-call",
    host: "",
    region: "",
    deadline: "",
    url: "",
    description: "",
  });

  const [loading, setLoading] = useState(true);

  // ❗ Hook는 무조건 조건문보다 위에 있어야 함
  useEffect(() => {
    fetchItem();
  }, [id]);

  async function fetchItem() {
    const { data, error } = await supabase
      .from("opportunities")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      console.error(error);
      return;
    }

    setForm({
      title: data.title,
      category: data.category,
      host: data.host || "",
      region: data.region || "",
      deadline: data.deadline || "",
      url: data.url || "",
      description: data.description || "",
    });

    setLoading(false);
  }

  // ❗ 이제 조건부 return은 Hook 아래에서 해야 함
  if (!user || user.userType !== "admin") {
    return <div className="p-6">Access denied.</div>;
  }

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();

    const { error } = await supabase
      .from("opportunities")
      .update({ ...form })
      .eq("id", id);

    if (error) {
      alert("Error: " + error.message);
      return;
    }

    alert("Updated successfully!");
    navigate(`/opportunities/${id}`);
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Edit Opportunity</h1>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">

        <input
          className="border px-3 py-2 rounded"
          placeholder="Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        <select
          className="border px-3 py-2 rounded"
          value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })}
        >
          <option value="open-call">Open Call</option>
          <option value="residency">Residency</option>
          <option value="international">International</option>
          <option value="study-abroad">Study Abroad</option>
        </select>

        <input
          className="border px-3 py-2 rounded"
          placeholder="Host"
          value={form.host}
          onChange={(e) => setForm({ ...form, host: e.target.value })}
        />

        <input
          className="border px-3 py-2 rounded"
          placeholder="Region (KR, JP, US…)"
          value={form.region}
          onChange={(e) => setForm({ ...form, region: e.target.value })}
        />

        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={form.deadline}
          onChange={(e) => setForm({ ...form, deadline: e.target.value })}
        />

        <input
          className="border px-3 py-2 rounded"
          placeholder="URL"
          value={form.url}
          onChange={(e) => setForm({ ...form, url: e.target.value })}
        />

        <textarea
          className="border px-3 py-2 rounded min-h-[120px]"
          placeholder="Description"
          value={form.description}
          onChange={(e) =>
            setForm({ ...form, description: e.target.value })
          }
        />

        <button
          type="submit"
          className="px-4 py-2 bg-black text-white rounded"
        >
          Save
        </button>
      </form>
    </div>
  );
}
